<template>
  <div v-show="isVisible">
    <v-text-field
      :label="schema.label || schema.title"
      type="number"
      v-model="clampedValue"
      :placeholder="schema.placeholder"
      :rules="rules"
      :disabled="isDisabled"
      :class="fieldClasses"
      :min="schema.min"
      :max="schema.max"
    />
  </div>
</template>

<script>
import GenericField from './GenericField';

export default {
  name: 'numberField',
  mixins: [GenericField],
  computed: {
    clampedValue: {
      get() {
        return this.localValue;
      },
      set(val) {
        let num = Number(val);
        if (this.schema.min !== undefined && num < this.schema.min) {
          num = this.schema.min;
        }
        if (this.schema.max !== undefined && num > this.schema.max) {
          num = this.schema.max;
        }
        this.localValue = num;
      },
    },
  },
};
</script>
